<template>
    <!-- Filter leads -->
    <CContainer fluid>
        <CRow alignHorizontal="end">
            <div class="position-relative">
                <CButton class="button__plain" @click="openModal()">
                    <CIcon :content="$options.icons.cilSettings" />
                </CButton>
            </div>
        </CRow>

        <CModal :show.sync="modals.tableSettings.show" :closeOnBackdrop="false">
            <template #header>
                <h4>
                    <CIcon :content="$options.icons.cilSettings" />
                    <span :style="{ 'padding-left': '10px' }">
                        {{ $t("table_settings") }}
                    </span>
                </h4>
            </template>

            <template #body-wrapper>
                <CContainer>
                    <CTabs>
                        <CTab :title="$t('fields')">
                            <div class="list-fields__wrapped">
                                <CListGroup>
                                    <CListGroupItem
                                        v-for="(
                                            field, index
                                        ) in componentActiveFields"
                                        :key="index"
                                    >
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <CInputCheckbox
                                                :checked.sync="field._active"
                                                :label="field.label"
                                                :disabled="field.fixed"
                                            />
                                            <CButton
                                                @click="
                                                    eventDisableField(field)
                                                "
                                                class="button__plain"
                                            >
                                                <CIcon
                                                    :content="
                                                        $options.icons.cilX
                                                    "
                                                    v-if="!field.fixed"
                                                />
                                                <CIcon
                                                    :content="
                                                        $options.icons
                                                            .cilLockLocked
                                                    "
                                                    v-else
                                                />
                                            </CButton>
                                        </div>
                                    </CListGroupItem>
                                </CListGroup>
                            </div>
                            <model-select
                                :options="componentParseDisableFields"
                                v-model="componentSelectField"
                                :placeholder="$t('Active a field')"
                                class="form-control"
                            >
                            </model-select>
                        </CTab>
                    </CTabs>
                </CContainer>
            </template>

            <template #footer-wrapper>
                <CContainer class="pt-3 pb-2">
                    <CRow :form="true">
                        <label
                            class="col-form-label col-md-4 col-form-label-md"
                            >{{ $t("advance_validation") }}</label
                        >
                        <div class="col-md-2">
                            <CSwitch
                                :checked.sync="componentAdvanceValidation"
                                color="primary"
                                name="action"
                                shape="pill"
                                variant="3d"
                                size="sm"
                            />
                        </div>
                        <CCol md="6">
                            <CContainer>
                                <CRow alignHorizontal="end">
                                    <CButton @click="eventCancelSettings()">
                                        {{ $t("cancel") }}
                                    </CButton>
                                    <CButton @click="saveSettings()">
                                        {{ $t("save") }}
                                    </CButton>
                                </CRow>
                            </CContainer>
                        </CCol>
                    </CRow>
                </CContainer>
            </template>
        </CModal>
    </CContainer>
</template>

<script>
/** Components */
import { ModelSelect } from "vue-search-select";
/** Mixins */
import baseMixin from "~/mixins/base.js";

/** Others */
import {
    cilFilter,
    cilListFilter,
    cilSettings,
    cilX,
    cilLockLocked,
} from "@coreui/icons";
import "vue-search-select/dist/VueSearchSelect.css";
import { normalizeTableField } from "~/utils/tables.js";
export default {
    name: "TableSettingsComponent",
    mixins: [baseMixin],
    icons: {
        cilFilter,
        cilListFilter,
        cilSettings,
        cilX,
        cilLockLocked,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            modals: {
                tableSettings: {
                    show: false,
                },
            },
            componentFields: [],
            componentSelectField: null,
            componentAdvanceValidation: false,
            componentTableFields: [],
            componentAllFields: [],
        };
    },
    props: {
        allFields: Array,
        activeFields: Array,
    },
    watch: {
        componentSelectField(newValue, oldValue) {
            if (newValue !== null) {
                this.eventActiveField(newValue);
                this.componentSelectField = null;
            }
        },
    },
    computed: {
        componentActiveFields() {
            return this.componentFields.filter((field) => {
                return field._active == true;
            });
        },
        componentParseDisableFields() {
            return this.componentDisableFields.map((field) => {
                return {
                    value: field.key,
                    text: field.label,
                };
            });
        },
        componentDisableFields() {
            return this.componentFields.filter((field) => {
                return field._active == false;
            });
        },
    },
    methods: {
        openModal() {
            this.modals.tableSettings.show = true;
            this.componentSelectField = null;
            this.mergeFields();
        },
        closeModal() {
            this.modals.tableSettings.show = false;
        },
        mergeFields() {
            this.componentTableFields = [...this.activeFields];
            this.componentTableFields = this.componentTableFields.map(
                (activeField) => {
                    return normalizeTableField(activeField, { _active: true });
                }
            );

            this.componentAllFields = [...this.allFields];
            this.componentAllFields = this.componentAllFields.map((field) => {
                return normalizeTableField(field);
            });

            let merge = [];
            let fields = [
                ...this.componentTableFields,
                ...this.componentAllFields,
            ];

            for (let i = 0; i < fields.length; i++) {
                let field = fields[i];


                if(field.key.startsWith("_")){
                    merge.push(field)
                }


                // No tomamos en cuenta los campos que empiezan "_{fieldKey}" son campos reservados
                if (!field.key.startsWith("_")) {
                    const findIndex = merge.findIndex((item) => {
                        
                        return item.key == field.key;
                    });

                    

                    // -1 is field not found
                    
                    if (findIndex == -1) {
                        merge.push(field);
                    }
                }
            }
            this.componentFields = [...merge];
            
        },
        saveSettings() {
            this.$emit("update:activeFields", [...this.componentActiveFields]);
            this.closeModal();
        },
        eventActiveField(value) {
            let findIndex = this.componentFields.findIndex((field) => {
                return value === field.key;
            });

            if (findIndex > -1) {
                this.componentFields[findIndex]._active = true;
            }
        },
        eventDisableField(value) {
            let findIndex = this.componentFields.findIndex((field) => {
                return value.key === field.key;
            });

            if (findIndex > -1) {
                this.componentFields[findIndex]._active = false;
            }
        },
        eventCancelSettings() {
            this.closeModal();
        },
    },
    mounted() {
        this.componentSelectField = null;
        this.mergeFields();
    },
    async created() {
        await this.loadFieldsAdvance();
    },
};
</script>

<style lang="scss" scoped>
.list-fields__wrapped {
    max-height: 50vh;
    overflow-y: auto;
}
</style>